export default {
  AUTHENTICATE_LOGIN: '/MstUserAdmin/login',
  AUTHENTICATE_LOGOUT: '/MstUserAdmin/logout',
};
